import React, { useState } from "react";
import AdminPanelLayout from "./AdminPanelLayout";
import logo2 from "../../assets/logo2 2.png";
import avatar from "../../assets/onsitepro-logo.png";
import { toast } from "react-toastify";

function Profile() {
  let currentUser = null;
  try {
    currentUser = JSON.parse(localStorage.getItem("user"));
  } catch {
    currentUser = null;
  }
  if (currentUser && !currentUser.avatar) currentUser.avatar = avatar;

  // Always use the image from user object if present, else default avatar
  const initialImage = currentUser?.image && currentUser.image !== "" ? currentUser.image : "";
  const [form, setForm] = useState({
    fullName: currentUser?.fullName || "",
    email: currentUser?.email || "",
    mobile: currentUser?.mobile || "",
    image: initialImage,
    password: "",
    confirmPassword: ""
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageCacheBuster, setImageCacheBuster] = useState(Date.now());
  const [displayName, setDisplayName] = useState(currentUser?.fullName || "");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue = name === "mobile" ? value.replace(/[^0-9]/g, "").slice(0, 12) : value;
    setForm((prev) => ({ ...prev, [name]: nextValue }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      setForm((prev) => ({ ...prev, image: file.name }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    if (form.password && form.password !== form.confirmPassword) {
      toast.error("Password and Confirm Password do not match.");
      setLoading(false);
      return;
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      let res, data;
      if (imageFile) {
        // Use FormData for file upload
        const formData = new FormData();
        formData.append('fullName', form.fullName);
        formData.append('email', form.email);
        formData.append('mobile', form.mobile);
        if (form.password) formData.append('password', form.password);
        if (form.confirmPassword) formData.append('confirmPassword', form.confirmPassword);
        formData.append('image', imageFile);
        res = await fetch(baseUrl + `/api/admin/${currentUser.id}`, {
          method: "PUT",
          body: formData
        });
      } else {
        // Fallback to JSON if no file selected
        const payload = { ...form };
        if (!form.password) delete payload.password;
        if (!form.confirmPassword) delete payload.confirmPassword;
        if (form.image && typeof form.image === 'string' && form.image.startsWith('data:image')) {
          payload.image = form.image;
        }
        res = await fetch(baseUrl + `/api/admin/${currentUser.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      }
      data = await res.json();
      if (res.ok && data.success) {
        toast.success("Profile updated successfully!");
        localStorage.setItem("user", JSON.stringify({ ...currentUser, ...form, password: undefined, confirmPassword: undefined, image: data.data.image }));
        setForm((prev) => ({ ...prev, password: "", confirmPassword: "", image: data.data.image }));
        setDisplayName(data.data.fullName || form.fullName);
        if (imagePreview) {
          URL.revokeObjectURL(imagePreview);
        }
        setImageFile(null);
        setImagePreview(null);
        setImageCacheBuster(Date.now()); // force reload of image from server
      } else {
        toast.error(data.message || "Update failed.");
      }
    } catch {
      toast.error("Server error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <AdminPanelLayout>
      <div className="container py-5">
        <div className="row g-4">
          <div className="col-lg-4 col-md-5">
            <div className="card shadow-sm border-0" style={{borderRadius:'16px', padding:'2rem 1.5rem', textAlign:'center', background:'#fff'}}>
              <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
                <div style={{position:'relative', marginBottom:16}}>
                  <div style={{width:130, height:130, borderRadius:'50%', overflow:'hidden', border:'4px solid #eaf0fe', boxShadow:'0 4px 16px rgba(139,22,52,0.10)', background:'#f7f7fa', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <img
                      src={
                        imagePreview
                          ? imagePreview
                          : (form.image && form.image !== ""
                              ? `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/uploads/${form.image}?cb=${imageCacheBuster}`
                              : '/default-avatar.png')
                      }
                      alt="Profile"
                      style={{width:'100%', height:'100%', objectFit:'contain', borderRadius:'50%'}}
                      onError={e => {
                        if (!imagePreview) e.target.src = '/default-avatar.png';
                      }}
                    />
                  </div>
                  <input type="file" accept="image/*" onChange={handleImageChange} style={{display:'none'}} id="profile-image-upload" />
                  <label htmlFor="profile-image-upload" style={{position:'absolute', bottom:0, right:0, background:'#fff', borderRadius:'50%', boxShadow:'0 2px 8px rgba(139,22,52,0.10)', border:'2px solid #8b1634', padding:8, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center'}} title="Change picture">
                    <i className="fa fa-camera" style={{color:'#8b1634', fontSize:20}}></i>
                  </label>
                </div>
                <h4 style={{fontWeight:700, color:'#8b1634', marginBottom:6}}>{displayName}</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-7">
            <div className="card shadow-sm border-0" style={{borderRadius:'16px', padding:'2rem 2rem 1.5rem 2rem', background:'#fff'}}>
              <h5 style={{fontWeight:700, color:'#8b1634', marginBottom:18}}>Profile</h5>
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-12">
                    <label className="form-label" style={{fontWeight:500}}>Full name *</label>
                    <input type="text" className="form-control" name="fullName" value={form.fullName} onChange={handleChange} style={{background:'#f7f7fa', borderRadius:'8px', border:'1.5px solid #eaeaea', color:'#8b1634'}} required />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" style={{fontWeight:500}}>Email address *</label>
                    <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} style={{background:'#f7f7fa', borderRadius:'8px', border:'1.5px solid #eaeaea', color:'#8b1634'}} required />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" style={{fontWeight:500}}>Phone number</label>
                    <input type="text" className="form-control" name="mobile" value={form.mobile} onChange={handleChange} style={{background:'#f7f7fa', borderRadius:'8px', border:'1.5px solid #eaeaea', color:'#8b1634'}} maxLength={12} inputMode="numeric" pattern="[0-9]*" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" style={{fontWeight:500}}>Password</label>
                    <input type="password" className="form-control" name="password" value={form.password} onChange={handleChange} style={{background:'#f7f7fa', borderRadius:'8px', border:'1.5px solid #eaeaea', color:'#8b1634'}} autoComplete="new-password" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label" style={{fontWeight:500}}>Confirm Password</label>
                    <input type="password" className="form-control" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} style={{background:'#f7f7fa', borderRadius:'8px', border:'1.5px solid #eaeaea', color:'#8b1634'}} autoComplete="new-password" />
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <button type="submit" className="btn" style={{background:'#8b1634', color:'#fff', borderRadius:'8px', fontWeight:600, fontSize:'1rem', minWidth:'120px'}} disabled={loading}>{loading ? "Saving..." : "Save details"}</button>
                </div>
                {/* Toast notifications will show for success/error messages */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </AdminPanelLayout>
  );
}

export default Profile;
